import AuthenticationLayout from 'components/AuthLayout';
import Button from 'components/Button';
import { FC } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Title = styled.h1`
  color: var(--gray-900);
  font-size: 1.2rem;
  font-weight: 500;
  margin-bottom: 1rem;
`;

const Text = styled.p`
  color: var(--gray-700);
  width: min(90%, 60rem);
  font-size: 1rem;
  margin-bottom: 1rem;
  font-weight: 400;
`;

const Welcome: FC = () => {
  return (
    <AuthenticationLayout src_image="/logo_institut_mentorat.png">
      <Container>
        <Title>
          Bienvenue dans l’espace du programme de mentorat de l’Institut de
          l’Engagement.
        </Title>

        <Text>
          Ce programme vise à accompagner de jeunes engagés et les aide à
          valoriser leur engagement et à construire leurs projets.
        </Text>
        <Text>
          Afin d’être mis en relation avec votre ou vos mentorés, merci de
          remplir le petit questionnaire et de signer la charte d'engagement.
        </Text>

        <Text>Merci pour votre engagement !</Text>
        <Link to="/mentor/fill-form">
          <Button color="primary">Compléter le formulaire de mentorat</Button>
        </Link>
      </Container>
    </AuthenticationLayout>
  );
};

export default Welcome;
